// minimal multi-purpose interface

// @requires utils color analyze
import chroma from '../chroma.js';
import { limit, type } from '../utils/index.js';
var pow = Math.pow;
export default function (colors) {
  // constructor
  var _mode = 'rgb';
  var _nacol = chroma('#ccc');
  var _spread = 0;
  // const _fixed = false;
  var _domain = [0, 1];
  var _pos = [];
  var _padding = [0, 0];
  var _classes = false;
  var _colors = [];
  var _out = false;
  var _min = 0;
  var _max = 1;
  var _correctLightness = false;
  var _colorCache = {};
  var _useCache = true;
  var _gamma = 1;

  // private methods

  var setColors = function setColors(colors) {
    colors = colors || ['#fff', '#000'];
    if (colors && type(colors) === 'string' && chroma.brewer && chroma.brewer[colors.toLowerCase()]) {
      colors = chroma.brewer[colors.toLowerCase()];
    }
    if (type(colors) === 'array') {
      // handle single color
      if (colors.length === 1) {
        colors = [colors[0], colors[0]];
      }
      // make a copy of the colors
      colors = colors.slice(0);
      // convert to chroma classes
      for (var c = 0; c < colors.length; c++) {
        colors[c] = chroma(colors[c]);
      }
      // auto-fill color position
      _pos.length = 0;
      for (var _c = 0; _c < colors.length; _c++) {
        _pos.push(_c / (colors.length - 1));
      }
    }
    resetCache();
    return _colors = colors;
  };
  var getClass = function getClass(value) {
    if (_classes != null) {
      var n = _classes.length - 1;
      var i = 0;
      while (i < n && value >= _classes[i]) {
        i++;
      }
      return i - 1;
    }
    return 0;
  };
  var tMapLightness = function tMapLightness(t) {
    return t;
  };
  var tMapDomain = function tMapDomain(t) {
    return t;
  };

  // const classifyValue = function(value) {
  //     let val = value;
  //     if (_classes.length > 2) {
  //         const n = _classes.length-1;
  //         const i = getClass(value);
  //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
  //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
  //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
  //     }
  //     return val;
  // };

  var getColor = function getColor(val, bypassMap) {
    var col, t;
    if (bypassMap == null) {
      bypassMap = false;
    }
    if (isNaN(val) || val === null) {
      return _nacol;
    }
    if (!bypassMap) {
      if (_classes && _classes.length > 2) {
        // find the class
        var c = getClass(val);
        t = c / (_classes.length - 2);
      } else if (_max !== _min) {
        // just interpolate between min/max
        t = (val - _min) / (_max - _min);
      } else {
        t = 1;
      }
    } else {
      t = val;
    }

    // domain map
    t = tMapDomain(t);
    if (!bypassMap) {
      t = tMapLightness(t); // lightness correction
    }
    if (_gamma !== 1) {
      t = pow(t, _gamma);
    }
    t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
    t = limit(t, 0, 1);
    var k = Math.floor(t * 10000);
    if (_useCache && _colorCache[k]) {
      col = _colorCache[k];
    } else {
      if (type(_colors) === 'array') {
        //for i in [0.._pos.length-1]
        for (var i = 0; i < _pos.length; i++) {
          var p = _pos[i];
          if (t <= p) {
            col = _colors[i];
            break;
          }
          if (t >= p && i === _pos.length - 1) {
            col = _colors[i];
            break;
          }
          if (t > p && t < _pos[i + 1]) {
            t = (t - p) / (_pos[i + 1] - p);
            col = chroma.interpolate(_colors[i], _colors[i + 1], t, _mode);
            break;
          }
        }
      } else if (type(_colors) === 'function') {
        col = _colors(t);
      }
      if (_useCache) {
        _colorCache[k] = col;
      }
    }
    return col;
  };
  var resetCache = function resetCache() {
    return _colorCache = {};
  };
  setColors(colors);

  // public interface

  var f = function f(v) {
    var c = chroma(getColor(v));
    if (_out && c[_out]) {
      return c[_out]();
    } else {
      return c;
    }
  };
  f.classes = function (classes) {
    if (classes != null) {
      if (type(classes) === 'array') {
        _classes = classes;
        _domain = [classes[0], classes[classes.length - 1]];
      } else {
        var d = chroma.analyze(_domain);
        if (classes === 0) {
          _classes = [d.min, d.max];
        } else {
          _classes = chroma.limits(d, 'e', classes);
        }
      }
      return f;
    }
    return _classes;
  };
  f.domain = function (domain) {
    if (!arguments.length) {
      return _domain;
    }
    _min = domain[0];
    _max = domain[domain.length - 1];
    _pos = [];
    var k = _colors.length;
    if (domain.length === k && _min !== _max) {
      // update positions
      for (var _i = 0, _Array$from = Array.from(domain); _i < _Array$from.length; _i++) {
        var d = _Array$from[_i];
        _pos.push((d - _min) / (_max - _min));
      }
    } else {
      for (var c = 0; c < k; c++) {
        _pos.push(c / (k - 1));
      }
      if (domain.length > 2) {
        // set domain map
        var tOut = domain.map(function (d, i) {
          return i / (domain.length - 1);
        });
        var tBreaks = domain.map(function (d) {
          return (d - _min) / (_max - _min);
        });
        if (!tBreaks.every(function (val, i) {
          return tOut[i] === val;
        })) {
          tMapDomain = function tMapDomain(t) {
            if (t <= 0 || t >= 1) return t;
            var i = 0;
            while (t >= tBreaks[i + 1]) i++;
            var f = (t - tBreaks[i]) / (tBreaks[i + 1] - tBreaks[i]);
            var out = tOut[i] + f * (tOut[i + 1] - tOut[i]);
            return out;
          };
        }
      }
    }
    _domain = [_min, _max];
    return f;
  };
  f.mode = function (_m) {
    if (!arguments.length) {
      return _mode;
    }
    _mode = _m;
    resetCache();
    return f;
  };
  f.range = function (colors, _pos) {
    setColors(colors, _pos);
    return f;
  };
  f.out = function (_o) {
    _out = _o;
    return f;
  };
  f.spread = function (val) {
    if (!arguments.length) {
      return _spread;
    }
    _spread = val;
    return f;
  };
  f.correctLightness = function (v) {
    if (v == null) {
      v = true;
    }
    _correctLightness = v;
    resetCache();
    if (_correctLightness) {
      tMapLightness = function tMapLightness(t) {
        var L0 = getColor(0, true).lab()[0];
        var L1 = getColor(1, true).lab()[0];
        var pol = L0 > L1;
        var L_actual = getColor(t, true).lab()[0];
        var L_ideal = L0 + (L1 - L0) * t;
        var L_diff = L_actual - L_ideal;
        var t0 = 0;
        var t1 = 1;
        var max_iter = 20;
        while (Math.abs(L_diff) > 1e-2 && max_iter-- > 0) {
          (function () {
            if (pol) {
              L_diff *= -1;
            }
            if (L_diff < 0) {
              t0 = t;
              t += (t1 - t) * 0.5;
            } else {
              t1 = t;
              t += (t0 - t) * 0.5;
            }
            L_actual = getColor(t, true).lab()[0];
            return L_diff = L_actual - L_ideal;
          })();
        }
        return t;
      };
    } else {
      tMapLightness = function tMapLightness(t) {
        return t;
      };
    }
    return f;
  };
  f.padding = function (p) {
    if (p != null) {
      if (type(p) === 'number') {
        p = [p, p];
      }
      _padding = p;
      return f;
    } else {
      return _padding;
    }
  };
  f.colors = function (numColors, out) {
    // If no arguments are given, return the original colors that were provided
    if (arguments.length < 2) {
      out = 'hex';
    }
    var result = [];
    if (arguments.length === 0) {
      result = _colors.slice(0);
    } else if (numColors === 1) {
      result = [f(0.5)];
    } else if (numColors > 1) {
      var dm = _domain[0];
      var dd = _domain[1] - dm;
      result = __range__(0, numColors, false).map(function (i) {
        return f(dm + i / (numColors - 1) * dd);
      });
    } else {
      // returns all colors based on the defined classes
      colors = [];
      var samples = [];
      if (_classes && _classes.length > 2) {
        for (var i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
          samples.push((_classes[i - 1] + _classes[i]) * 0.5);
        }
      } else {
        samples = _domain;
      }
      result = samples.map(function (v) {
        return f(v);
      });
    }
    if (chroma[out]) {
      result = result.map(function (c) {
        return c[out]();
      });
    }
    return result;
  };
  f.cache = function (c) {
    if (c != null) {
      _useCache = c;
      return f;
    } else {
      return _useCache;
    }
  };
  f.gamma = function (g) {
    if (g != null) {
      _gamma = g;
      return f;
    } else {
      return _gamma;
    }
  };
  f.nodata = function (d) {
    if (d != null) {
      _nacol = chroma(d);
      return f;
    } else {
      return _nacol;
    }
  };
  return f;
}
function __range__(left, right, inclusive) {
  var range = [];
  var ascending = left < right;
  var end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (var i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}